import { useEffect, useState, type FunctionComponent, PropsWithChildren, } from "react";
import { createPortal, } from "react-dom";
import { useLegalStore, } from "@stores/legal";
import { useModalizeStore, } from "../Modalize";
import { Button, } from "@bracket/react-button";

import "./RegionShield.scss";

export declare type RegionShieldProps = PropsWithChildren & {

};


export const RegionShield: FunctionComponent<RegionShieldProps> = ({
	children,
}) => {

	const {
		country,
		country_lock,
		country_checked,
		account_lock,
		account_checked,
	} = useLegalStore();

	const classes = () => [ `region-shield` ].join(" ");
	const [ element, setElement, ] = useState<HTMLDivElement | null>(null);
	const el = window.document.querySelector("body");
	const id = "region-shield-brace";

	useEffect(() => {
		if( el ) {
			const node = document.createElement('div');
			const exists = el.querySelector(id);
			if( !exists ) {
				node.id = id;
				el.appendChild(node);
				setElement(node);
			}
			return;
		}
		throw new Error("RegionShield failed to obtain a referencde to the document body");
	}, []);

	const onReturnHome = ( ) => {
		window.open("https://www.bracket.fi", "_self");
	}


	if( !element ) return null;

	if( ( !country_checked || !account_checked ) || ( !account_lock || !country_lock ) ) {
		return <>{ children }</>
	}

	return createPortal((
		<div className={classes()}>
			<div className="panel">
				<div className="title"><h3>Region Restriction</h3></div>
				<div className="content"><p>Sorry! your region [{country}] is not being supported by Bracket at the current time.</p></div>
				<br />
				<br />
				<Button label="Return home" onClick={onReturnHome} className="return-home" />
			</div>
		</div>
	), element);

}
